import React, { useRef, useState } from "react";
import { Upload, message } from "antd";
import "./ImagesUpload.less";
import PreviewContainer from "./PreviewContainer";

const ImageUploader = ({ isCustomPreview = true, ...props }) => {
    const uploaderRef = useRef();
    const [fileList, updateFileList] = useState(props.fileList);
    const uploadDocument = ({ file, fileList, onSuccess }) => {
        setTimeout(() => {
            onSuccess("ok");
        }, 0);
    };

    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };
    const UploadProps = {
        ...props,
        fileList,
        beforeUpload: (file) => {
            let supported = props.supportedFormats.includes(file.type);
            if (!supported) {
                message.error(`${file.name} is not supported`);
            } else {
                const fileSizeLimit =
                    file.size / 1024 / 1024 < props.maxFileSize;
                if (!fileSizeLimit) {
                    message.error(
                        `File must be smaller than ${props.maxFileSize}MB!`
                    );

                    supported = false;
                }
            }

            return supported;
        },
        onChange: async (info) => {
            let imgUrlArrayCount = 0;
            let maxCount = props?.maxCount || -1;
            if (
                Array.isArray(props?.imageUrls) &&
                props?.imageUrls.length > 0
            ) {
                imgUrlArrayCount = props.imageUrls.length;
            }
            if (imgUrlArrayCount === maxCount) return;
            const { fileList } = info;
            let value = fileList
                .map((singleFileList, index) => {
                    const isLimitExceed = imgUrlArrayCount + index + 1;

                    if (maxCount !== -1 && maxCount < isLimitExceed)
                        return undefined;
                    return singleFileList;
                })
                .filter((file) => !!file && !!file.status);
            updateFileList(value);

            let filePreviewArray = [];
            if (!!fileList) {
                // const normalizeList = fileList
                //     .map(async (singleFileList, index) => {
                //         const isLimitExceed =
                //             maxCount - imgUrlArrayCount - fileList.length;
                //         if (maxCount !== -1 && isLimitExceed <= 0) return;
                //         const result = await getBase64(
                //             singleFileList.originFileObj
                //         );
                //         return { image: result };
                //     })
                //     .filter((v) => v !== undefined);
                const normalizeList = fileList
                    .map((singleFileList, index) => {
                        const isLimitExceed = imgUrlArrayCount + index + 1;
                        if (maxCount !== -1 && maxCount < isLimitExceed)
                            return null;
                        return singleFileList;
                    })
                    .filter((v) => v !== undefined);

                filePreviewArray = await Promise.all(
                    normalizeList.map(async (singleFileList, index) => {
                        const result = await getBase64(
                            singleFileList.originFileObj
                        );
                        return { image: result };
                    })
                );
                if (typeof props.filePreviewCallback === "function")
                    props.filePreviewCallback(filePreviewArray);
            }
            props.onChange(value);
        },
        onPreview: async (file) => {
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
        },
    };

    const onRemove = (file, index) => {
        let cloneImages = [...fileList];
        cloneImages.splice(index, 1);
        updateFileList(cloneImages);
        props.onChange(cloneImages);
    };

    return (
        <div className="image-uploader">
            {!props.isCustomPreview && Array.isArray(props?.fileList) && (
                <div className="image-preview ">
                    {props?.fileList.map((item, index) => {
                        return (
                            <PreviewContainer
                                showCloseButton
                                item={item}
                                isUrl={false}
                                key={index}
                                onClose={() => onRemove(item, index)}
                            />
                        );
                    })}
                </div>
            )}
            {!props.isCustomPreview && Array.isArray(props?.imageUrls) && (
                <div className="image-preview ">
                    {props?.imageUrls.map((item, index) => {
                        return (
                            <PreviewContainer
                                showCloseButton
                                item={item}
                                isUrl={true}
                                key={index}
                                onClose={() => props?.onImageDelete(item)}
                            />
                        );
                    })}
                </div>
            )}
            <Upload
                customRequest={uploadDocument}
                {...UploadProps}
                listType="picture"
                ref={uploaderRef}
            >
                {props.children}
            </Upload>
        </div>
    );
};

export default ImageUploader;
